import React, { useState } from 'react';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
// components
import ForgotPasswordForm from '../../components/Form/ForgotPasswordForm';
// API
import Api from '../../API';

const ForgotPassword = () => {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [disabled, setDisabled] = useState(false);

  const sendForgotPasswordRequset = async (email) => {
    setLoading(true);
    const response = await Api.forgotPassword(email);

    if (response.error) {
      if (response.error.startsWith('Too many requests')) {
        setDisabled(true);
      }
      setError(response.error);
      setSuccess('');
    } else {
      setError('');
      setSuccess(
        'If a user with this email exists an reset password email will be sent.'
      );
    }
    setLoading(false);
  };

  return (
    <Container className='pt-5'>
      {loading && (
        <div className={'my-5 text-center'}>
          <Spinner
            animation='border'
            variant='primary'
            className={'text-center'}
          />
        </div>
      )}
      {
        <Alert
          className='mt-5'
          variant={error ? 'danger' : 'success'}
          show={error || success}
        >
          {error || success}
        </Alert>
      }
      <h2 className='text-center'>
        <span style={{ color: 'blue' }}>Lost your password?</span> Please enter
        your email address you registerd with.
        <br />
        You will receive a link to create a new password via email.
      </h2>
      <ForgotPasswordForm
        className='mt-5'
        callback={sendForgotPasswordRequset}
        disabled={disabled}
      />
    </Container>
  );
};

export default ForgotPassword;
